import * as React from 'react';
import { IKeyboardContext, keyboardContext } from './KeyboardContext';
import { IContextualMenuItem } from 'office-ui-fabric-react/lib/ContextualMenu';

export interface IKeyboardShortcutProps {
  key: string;
  cmdKey: string;
  keySequences: string[];
  description?: string;
  onExecute?: (ev?: React.KeyboardEvent<HTMLElement> | undefined, item?: IContextualMenuItem | undefined)
    => boolean | void;
}

export interface IKeyboardShortcutBaseProps extends IKeyboardShortcutProps {
  registerKeyboardShortcut?: (props: IKeyboardShortcutProps) => () => void;
}

export class KeyboardShortcutBase extends React.PureComponent<IKeyboardShortcutBaseProps> {
  private _dispose?: () => void;

  public render(): JSX.Element | null {
    return null;
  }

  public componentDidMount(): void {
    if (this.props.registerKeyboardShortcut) {
      this._dispose = this.props.registerKeyboardShortcut(this.props);
    }
  }

  public componentWillUnmount(): void {
    const dispose = this._dispose;

    if (dispose) {
      dispose();
    }
  }
}

export class KeyboardShortcut extends React.PureComponent<IKeyboardShortcutProps> {
  public render(): JSX.Element | null {
    return (
      <keyboardContext.Consumer>
        { ({ keyboardManager }: IKeyboardContext) => {
          return (
            <KeyboardShortcutBase
              { ...this.props }
              registerKeyboardShortcut={ keyboardManager.registerKeyboardShortcut }
            />
          );
        } }
      </keyboardContext.Consumer>
    );
  }
}
